/* eslint-disable max-depth */
/* eslint-disable complexity */
/* eslint-disable max-statements */
/* eslint-disable max-lines */
import { CheckboxChangeEvent } from "antd/lib/checkbox"
import { OptionItemType } from "../../../../../../../_webui/layout/components/Select/models"
import { GeneralCode } from "../../../../../../../constant/GeneralCode"
import { Routers } from "../../../../../../../constant/Routers"
import { SelectItems } from "../../../../../../../constant/SelectItems"
import { AxiosErrorType } from "../../../../../../../infrastructure/axiosError/models"
import { countriesApi } from "../../../../../../../infrastructure/handlers/countries"
import { CitiesResType } from "../../../../../../../infrastructure/handlers/countries/models"
import { getDateRange, getDateUtc } from "../../../../../../../utils/getDate"
import { pushStateError } from "../../../../../../../utils/pushStateError"
import { replaceString } from "../../../../../../../utils/replaceString"
import { scrollToCollapseItem } from "../../../../../../../utils/scrollToCollapseItem"
import { translateMessage } from "../../../../../../../utils/translateMessage"
import { scheduleApi } from "../../../../apis"
import { SchedulesAddDetailRow } from "../../../../constants/add/addDetailRow"
import { InitialValues } from "../../../../constants/add/initialValues"
import { RequiredFields } from "../../../../constants/add/requiredFields"
import { Variables } from "../../../../constants/add/variables"
import {
  GetPurposeTravelListProps,
  HandleSetDetailDataSourceType,
  InitialValuesType,
  ScheduleDetailsType,
  ScheduleInfoDetailsType,
  ScheduleInfoType,
} from "../../../../models/add"
import { getDetailRequiredFields } from "../../utils/getDetailRequiredFields"
import { setDetailFieldValue } from "../../utils/setDetailFieldValue"
import { setNameRowDetail } from "../../utils/setNameRowDetail"
import { setNameRowStay } from "../../utils/setNameRowStay"
import { useSchedulesAddTabConfig } from "../useTabConfigs"
import { useTableDetailsConfig } from "../useTableConfigs/details"
import { useTableRemarksConfig } from "../useTableConfigs/remarks"
import { useTableLodgingsConfig } from "../useTableConfigs/lodgings"
import { useTableStaysConfig } from "../useTableConfigs/stays"
import { useVariablesHandle } from "../useVariablesHandle"
import { getLodgingRequiredFields } from "../../utils/getLodgingRequiredFields"
import { getStayRequiredFields } from "../../utils/getStayRequiredFields"
import { FormErrorType } from "../../../../../../../_webui/layout/components/Form/models"
import { useDatePicker } from "../../../../../../../utils/hook/useDatePicker"
import { requiredField } from "../../../../../../../utils/requiredField"
import { setNameRowLodging } from "../../utils/setNameRowLodging"
import { Translate } from "../../../../../../../constant/Translate"
import { TravelersDetailResType } from "../../../../../travelers/models/detail"
import { getValueByLanguage } from "../../../../../../../utils/getValueByLanguage"
import { MouseEvent } from "react"
import { AnyValue } from "../../../../../../../_webui/layout/models"

const {
  ACCOMMODATION_DATA_SOURCE_NEW,
  INITIAL_VALUES_REMARK_NAMES,
  ITINERARY_DATA_SOURCE_NEW,
  PLACE_OF_STAY_CONTACT_DATA_SOURCE_NEW,
} = InitialValues
const {
  DPTD_KEY3_2,
  DPTD_KEY3_7,
  OTHER,
  PPTV_HIRED_LOCALLY,
  PPTV_DOMESTIC_TRAVEL,
  TPTT001,
} = GeneralCode
const { INSURANCE_REQUIRED_FIELDS, SCHEDULES_ADD_REQUIRED_FIELDS } =
  RequiredFields
const { SCR212, SCR212_USER, SCR960, SCR973 } = Routers
const { ARRIVAL } = SchedulesAddDetailRow
const { OTHER_CITY_SELECT_ITEMS } = SelectItems
const {
  DPTD_HIRED_LOCALLY,
  DPTD_REQUIRED_URGENT_CONTACT,
  DPTD_TRAINEE,
  E0017,
  E0105,
  E0107,
  PPTV_BUSINESS_TRAVEL,
  REGEX_ARRIVAL_DEPARTURE_VALIDATION_TRIGGER_FIELD,
} = Variables
const { MESSAGE_E0160, TEXT_T100 } = Translate

export const useHandle = (isVisibleBtn: boolean) => {
  const {
    allCountries,
    assignmentValidMsg,
    dataSubmit,
    defaultActiveKey,
    defaultCountries,
    departments,
    detailDataSource,
    detailIndexIdentity,
    detailIndexTabActive,
    detailRequiredFields,
    detailRowSelection,
    detailSelectedRowKeys,
    detailValidMsg,
    dispatchType,
    dispatchTypeDetailRes,
    flightNumberList,
    flightNumberListAll,
    form,
    generalMastersRemark,
    id,
    isAccompanyingFamily,
    isActiveBumon,
    isCheckTwoWay,
    isDifferentInfoChecked,
    isDisabledSubmit,
    isHiredLocally,
    isInsuranceAndUrgent,
    isInsuranceRequired,
    isOpen,
    isOpenRoundTrip,
    isOtherStaffNumber,
    isRequiredItemTableByDate,
    isRequiredItemTableByPPTV,
    isRequiredItemTableDetails,
    isRequiredItemTableLodgings,
    isSubmitValidate,
    isTwoWay,
    listPPTVIsValue3Equal1,
    listPPTVIsValue4Equal2,
    listPPTVIsValue5EqualTwoWay,
    lodgingDataSource,
    lodgingIndexIdentity,
    lodgingIndexTabActive,
    lodgingRequiredFields,
    lodgingRowSelection,
    lodgingSelectedRowKeys,
    lodgingValidMsg,
    onCancel,
    onCancelRoundTripModal,
    onOpen,
    onOpenRoundTrip,
    pathname,
    purposeTravelList,
    purposeTravelRes,
    push,
    scheduleDetails,
    scheduleLodgings,
    schedulesData,
    scheduleStays,
    setAssignmentValidMsg,
    setDataSubmit,
    setDefaultActiveKey,
    setDefaultCountries,
    setDepartments,
    setDetailDataSource,
    setDetailIndexIdentity,
    setDetailIndexTabActive,
    setDetailRequiredFields,
    setDetailSelectedRowKeys,
    setDetailValidMsg,
    setDispatchType,
    setDispatchTypeDetailRes,
    setFlightNumberList,
    setFlightNumberListAll,
    setIsAccompanyingFamily,
    setIsActiveBumon,
    setIsCheckAllDetail,
    setIsCheckAllLodging,
    setIsCheckAllStay,
    setIsCheckTwoWay,
    setIsDifferentInfoChecked,
    setIsDisabledSubmit,
    setIsHiredLocally,
    setIsInsuranceAndUrgent,
    setIsInsuranceRequired,
    setIsOtherStaffNumber,
    setIsRequiredItemTableByDate,
    setIsRequiredItemTableByPPTV,
    setIsRequiredItemTableDetails,
    setIsRequiredItemTableLodgings,
    setIsSubmitValidate,
    setIsTwoWay,
    setListPPTVIsValue3Equal1,
    setListPPTVIsValue4Equal2,
    setListPPTVIsValue5EqualTwoWay,
    setLodgingDataSource,
    setLodgingIndexIdentity,
    setLodgingIndexTabActive,
    setLodgingRequiredFields,
    setLodgingSelectedRowKeys,
    setLodgingValidMsg,
    setPurposeTravelList,
    setPurposeTravelRes,
    setSchedulesData,
    setStayDataSource,
    setStayIndexIdentity,
    setStayIndexTabActive,
    setStayRequiredFields,
    setStaySelectedRowKeys,
    setTravelerBumonCd,
    setTravelerId,
    setWorkPlaceCountryCode,
    setWorkPlaceLocation,
    state,
    stayDataSource,
    stayIndexIdentity,
    stayIndexTabActive,
    stayRequiredFields,
    stayRowSelection,
    staySelectedRowKeys,
    transportationList,
    travelerBumonCd,
    travelerId,
    workPlaceCountryCode,
    workPlaceLocation,
  } = useVariablesHandle()

  const isRequiredLocationPhoneNumber1 =
    !isHiredLocally && isRequiredItemTableByPPTV

  const isRequiredLabelLodgings =
    isRequiredLocationPhoneNumber1 &&
    (isRequiredItemTableByDate || isRequiredItemTableLodgings)

  const handleError = (error: AxiosErrorType) => {
    // 「SCR973_エラー情報の表示画面」に遷移する。
    const stateError = pushStateError(error)
    push({ pathname: SCR973, state: stateError })
  }

  const onClickDetailTab = (activeKey: string) => {
    setDetailIndexTabActive(activeKey)
  }

  // [START] JICAMT2302-1042 (#Req 2): Validate arrival country/city match departure country/city same record
  const onValidateArrivalMatchDepartureSameRecord = () => {
    const hasSameArrivalDepartureRow = detailDataSource.some(({ index }) => {
      const itemName = setNameRowDetail(index)
      const arrivalCityCode = form.getFieldValue(`${itemName}.arrivalCityCode`)
      const arrivalCityName = form.getFieldValue(`${itemName}.arrivalCityName`)
      const arrivalCountryCode = form.getFieldValue(
        `${itemName}.arrivalCountryCode`,
      )
      const departureCityCode = form.getFieldValue(
        `${itemName}.departureCityCode`,
      )
      const departureCityName = form.getFieldValue(
        `${itemName}.departureCityName`,
      )
      const departureCountryCode = form.getFieldValue(
        `${itemName}.departureCountryCode`,
      )

      if (
        !arrivalCountryCode ||
        !arrivalCityCode ||
        !departureCountryCode ||
        !departureCityCode
      ) {
        return false
      }

      const isSameArrivalDepartureInRow =
        arrivalCountryCode === departureCountryCode &&
        arrivalCityCode === departureCityCode &&
        (arrivalCityName || "") === (departureCityName || "")

      if (isSameArrivalDepartureInRow && !isHiredLocally) {
        form.setFields([
          {
            errors: [MESSAGE_E0160],
            name: `${itemName}.arrivalCountryCode`,
          },
        ])
      } else {
        form.setFields([
          {
            errors: [],
            name: `${itemName}.arrivalCountryCode`,
          },
        ])
      }

      return isSameArrivalDepartureInRow
    })

    return hasSameArrivalDepartureRow
  }
  // [END] JICAMT2302-1042 (#Req 2): Validate arrival country/city match departure country/city same record

  const handleSetDetailItem = () => {
    const travelDetailId = `tempId${new Date().getTime().toString()}`
    const currentElement = setNameRowDetail(detailIndexIdentity)
    const previousItem = detailDataSource[detailDataSource.length - 1]

    if (PPTV_DOMESTIC_TRAVEL.includes(form.getFieldValue("travelPurposeId"))) {
      form.setFieldsValue({
        [`${currentElement}.departureCountryCode`]: workPlaceCountryCode,
        [`${currentElement}.arrivalCountryCode`]: workPlaceCountryCode,
        [`${currentElement}.departureCityCode`]: "",
        [`${currentElement}.arrivalCityCode`]: "",
      })

      setDetailDataSource((prevState) => [
        ...prevState,
        {
          ...ITINERARY_DATA_SOURCE_NEW,
          arrivalCities: defaultCountries,
          departureCities: defaultCountries,
          index: detailIndexIdentity,
          isTransit: Number(ITINERARY_DATA_SOURCE_NEW.isTransit),
          key: travelDetailId,
          remarkNames: INITIAL_VALUES_REMARK_NAMES,
          travelDetailId,
        },
      ])
    } else {
      setDetailDataSource((prevState) => {
        return [
          ...prevState,
          {
            ...ITINERARY_DATA_SOURCE_NEW,
            departureCities: previousItem?.arrivalCities || [],
            departureCityCode: previousItem?.arrivalCityCode,
            departureCityName: previousItem?.arrivalCityName,
            departureCityNameOther: previousItem?.arrivalCityNameOther,
            departureCountryCode: previousItem?.arrivalCountryCode,
            index: detailIndexIdentity,
            isTransit: Number(ITINERARY_DATA_SOURCE_NEW.isTransit),
            key: travelDetailId,
            remarkNames: INITIAL_VALUES_REMARK_NAMES,
            travelDetailId,
          },
        ]
      })
    }
    form.setFieldValue(`${currentElement}.travelDetailId`, travelDetailId)
    form.setFieldValue(
      `${currentElement}.isTransit`,
      Number(ITINERARY_DATA_SOURCE_NEW.isTransit),
    )

    const identityValue = detailIndexIdentity + 1
    setIsCheckAllDetail(false)
    setDetailIndexIdentity(identityValue)
    setDetailIndexTabActive((detailDataSource.length + 1).toString())

    return { currentElement, previousItem }
  }

  // SCR212_detail_add
  const handleAddDetailItem = (event?: MouseEvent<HTMLElement>) => {
    const { currentElement, previousItem } = handleSetDetailItem()

    if (detailIndexIdentity) {
      setTimeout(() => {
        if (event)
          document.getElementById(`${currentElement}.transportation`)?.focus()
        const previousElement = setNameRowDetail(previousItem.index)
        form.setFields([
          {
            errors: [],
            name: `${currentElement}.departureCountryCode`,
            value: form.getFieldValue(`${previousElement}.arrivalCountryCode`),
          },
          {
            errors: [],
            name: `${currentElement}.departureCityCode`,
            value: form.getFieldValue(`${previousElement}.arrivalCityCode`),
          },
          {
            errors: [],
            name: `${currentElement}.departureCityName`,
            value: form.getFieldValue(`${previousElement}.arrivalCityName`),
          },
        ])
      }, 100)
    }
  }

  // SCR212_detail_delete
  const handleDeleteDetailItem = (travelDetailId?: string) => {
    if (travelDetailId) {
      const _detailDataSource = detailDataSource.filter(
        (item) => item.travelDetailId !== travelDetailId,
      )

      setDetailDataSource(_detailDataSource)

      setDetailIndexTabActive("1")

      if (!_detailDataSource.length) handleSetDetailItem()
    } else {
      const _detailDataSource = detailDataSource.filter(
        (item) => !detailSelectedRowKeys.includes(item.travelDetailId),
      )

      setDetailDataSource(_detailDataSource)

      setDetailSelectedRowKeys([])

      if (!_detailDataSource.length) handleSetDetailItem()
    }

    setTimeout(() => {
      const elmRows = document.querySelectorAll(
        "#table-schedules-add-detail tbody > tr",
      )
      const emlInput = elmRows[elmRows.length - 1]?.querySelector(
        "td:nth-child(4) input",
      ) as HTMLInputElement
      emlInput?.focus()
    }, 100)
  }

  const handleSetFieldsValue = (
    data: ScheduleInfoDetailsType[],
    currentItem: ScheduleInfoDetailsType,
    currentIndex: number,
    fieldNames: string,
    value: string | OptionItemType[],
    isSetList: boolean,
    cityNames: string[],
    arrivalCountryCode?: string,
  ) => {
    const baseFieldName = `${setNameRowDetail(currentItem.index)}`

    if (isSetList) {
      if (arrivalCountryCode) {
        const dataRemark = generalMastersRemark?.find(
          (item) => item.key1 === arrivalCountryCode,
        )

        const remarkNames = dataRemark
          ? dataRemark
          : INITIAL_VALUES_REMARK_NAMES

        data.splice(currentIndex, 1, {
          ...currentItem,
          arrivalCountryCode: arrivalCountryCode,
          [fieldNames]: [...value, OTHER_CITY_SELECT_ITEMS],
          [cityNames[0]]: "",
          remarkNames,
        })
      } else
        data.splice(currentIndex, 1, {
          ...currentItem,
          [fieldNames]: [...value, OTHER_CITY_SELECT_ITEMS],
          [cityNames[0]]: "",
        })

      form?.setFieldsValue({
        [`${baseFieldName}.${cityNames[0]}`]: "",
        [`${baseFieldName}.${cityNames[1]}`]: "",
      })
    } else {
      data.splice(currentIndex, 1, {
        ...currentItem,
        [fieldNames]: value,
      })

      form?.setFieldsValue({
        [`${baseFieldName}.${cityNames[1]}`]: "",
      })

      if (value !== OTHER) {
        if (fieldNames === "departureCityCode")
          form?.resetFields([
            `${setNameRowDetail(currentIndex)}.departureCityName`,
          ])

        if (fieldNames === "arrivalCityCode")
          form?.resetFields([
            `${setNameRowDetail(currentIndex)}.arrivalCityName`,
          ])
      }
    }
  }

  const handleSetDetailRequiredFields = () => {
    if (detailDataSource.length) {
      const requiredFields: string[] = []
      if (isHiredLocally) {
        setDetailRequiredFields(requiredFields)
      } else {
        detailDataSource.forEach((item) => {
          if (typeof item.index === "number") {
            const {
              index,
              transportation,
              departureCityCode,
              arrivalCityCode,
            } = item

            const data = getDetailRequiredFields(index)

            if (transportation === TPTT001)
              data.push(`${setNameRowDetail(index)}.departureFlightNumber`)

            if (departureCityCode === OTHER)
              data.push(`${setNameRowDetail(index)}.departureCityName`)

            if (arrivalCityCode === OTHER)
              data.push(`${setNameRowDetail(index)}.arrivalCityName`)

            requiredFields.push(...data)
          }
        })
        setDetailRequiredFields(requiredFields)
      }
    }
  }

  const handleSetLodgingRequiredFields = () => {
    if (lodgingDataSource.length) {
      const requiredFields: string[] = []
      if (isHiredLocally) {
        setLodgingRequiredFields(requiredFields)
      } else {
        lodgingDataSource.forEach((item) => {
          if (typeof item.index === "number") {
            const { index } = item

            if (isRequiredLabelLodgings) {
              const data = getLodgingRequiredFields(index)
              requiredFields.push(...data)
            } else {
              const data = getLodgingRequiredFields(index)
              requiredFields.filter((item) => !data.includes(item))
              form.setFields([
                {
                  errors: [],
                  name: `${setNameRowLodging(index)}.lodgingCheckin`,
                },
                {
                  errors: [],
                  name: `${setNameRowLodging(index)}.lodgingCheckout`,
                },
                {
                  errors: [],
                  name: `${setNameRowLodging(index)}.lodgingName`,
                },
              ])
            }
          }
        })
        setLodgingRequiredFields(requiredFields)
      }
    }
  }

  const handleSetStayRequiredFields = () => {
    if (stayDataSource.length) {
      const requiredFields: string[] = []

      stayDataSource.forEach((item) => {
        if (typeof item.index === "number") {
          const { index } = item
          const data = getStayRequiredFields(
            index,
            isRequiredLocationPhoneNumber1,
          )

          requiredFields.push(...data)
        }
      })

      setStayRequiredFields(requiredFields)
    }
  }

  const handleSetDataSource = (
    travelerDetailId: string,
    type: string,
    fieldNames: string[],
    value: string | OptionItemType[],
    isSetList: boolean,
    arrivalCountryCode?: string,
  ) => {
    const currentItem = detailDataSource.find(
      (item) => item.travelDetailId === travelerDetailId,
    )

    if (currentItem) {
      const currentIndex = detailDataSource.findIndex(
        (item) => item.travelDetailId === travelerDetailId,
      )

      if (type === ARRIVAL) {
        const nextData = detailDataSource[currentIndex + 1]
        if (nextData && currentItem.index !== detailIndexIdentity - 1) {
          const currentElement = setNameRowDetail(
            detailDataSource[currentIndex].index,
          )
          const nextElement = setNameRowDetail(nextData.index)
          if (!form.getFieldValue(`${nextElement}.departureCountryCode`)) {
            form.setFieldValue(
              `${nextElement}.departureCountryCode`,
              form.getFieldValue(`${currentElement}.arrivalCountryCode`),
            )
            const nextItem = detailDataSource.find(
              (item) => item.travelDetailId === nextData.travelDetailId,
            )
            if (nextItem) {
              const nextIndex = detailDataSource.findIndex(
                (item) => item.travelDetailId === nextData.travelDetailId,
              )
              setDetailDataSource((prevState) => {
                const data = [...prevState]
                handleSetFieldsValue(
                  data,
                  currentItem,
                  currentIndex,
                  fieldNames[1],
                  value,
                  isSetList,
                  ["arrivalCityCode", "arrivalCityName"],
                  arrivalCountryCode,
                )
                handleSetFieldsValue(
                  data,
                  nextItem,
                  nextIndex,
                  fieldNames[0],
                  value,
                  isSetList,
                  ["departureCityCode", "departureCityName"],
                )
                form.setFields([
                  {
                    errors: [],
                    name: `${nextElement}.departureCountryCode`,
                  },
                ])
                data[nextIndex] = {
                  ...data[nextIndex],
                  departureCityCode: data[currentIndex].arrivalCityCode,
                }
                return data
              })
            }
          } else {
            setDetailDataSource((prevState) => {
              const data = [...prevState]
              handleSetFieldsValue(
                data,
                currentItem,
                currentIndex,
                fieldNames[1],
                value,
                isSetList,
                ["arrivalCityCode", "arrivalCityName"],
                arrivalCountryCode,
              )
              return data
            })
          }
          if (
            !form.getFieldValue(`${nextElement}.departureCityCode`) &&
            form.getFieldValue(`${currentElement}.arrivalCountryCode`) ===
              form.getFieldValue(`${nextElement}.departureCountryCode`)
          ) {
            form.setFields([
              {
                errors: [],
                name: `${nextElement}.departureCityCode`,
                value: form.getFieldValue(`${currentElement}.arrivalCityCode`),
              },
            ])
            setDetailDataSource((prevState) => {
              const data = [...prevState]
              const nextIndex = detailDataSource.findIndex(
                (item) => item.travelDetailId === nextData.travelDetailId,
              )
              if (nextIndex) {
                data[nextIndex] = {
                  ...data[nextIndex],
                  departureCityCode: data[currentIndex].arrivalCityCode,
                  departureCountryCode: data[currentIndex].arrivalCountryCode,
                }
              }
              return data
            })
          }
        } else {
          setDetailDataSource((prevState) => {
            const data = [...prevState]
            handleSetFieldsValue(
              data,
              currentItem,
              currentIndex,
              fieldNames[1],
              value,
              isSetList,
              ["arrivalCityCode", "arrivalCityName"],
              arrivalCountryCode,
            )
            return data
          })
        }
      } else {
        setDetailDataSource((prevState) => {
          const data = [...prevState]

          data[currentIndex] = {
            ...data[currentIndex],
            departureCountryCode: form.getFieldValue(
              `${setNameRowDetail(currentItem.index)}.departureCountryCode`,
            ),
          }

          handleSetFieldsValue(
            data,
            currentItem,
            currentIndex,
            fieldNames[0],
            value,
            isSetList,
            ["departureCityCode", "departureCityName"],
          )
          return data
        })
      }
    }
  }

  const onChangeCountry = (
    travelerDetailId: string,
    value: string,
    type: string,
  ) => {
    // APIを呼び出し、都市一覧情報を取得する。
    countriesApi
      .getCitiesByCountry(value)
      .then((res: CitiesResType[]) => {
        const optionItem: OptionItemType[] = res.map((item) => ({
          text: item.cityDistrict,
          value: item.cityCode,
        }))

        handleSetDataSource(
          travelerDetailId,
          type,
          ["departureCities", "arrivalCities"],
          optionItem,
          true,
          value,
        )
      })
      .catch((error: AxiosErrorType) => {
        handleError(error)
      })
  }

  const onChangeCity = (
    travelerDetailId: string,
    value: string,
    type: string,
  ) => {
    handleSetDataSource(
      travelerDetailId,
      type,
      ["departureCityCode", "arrivalCityCode"],
      value,
      false,
    )
    setIsTwoWay(false)
  }

  const onBlurDepartureCityName = (value: string, travelDetailId: string) => {
    const currentIndex = detailDataSource.findIndex(
      (item) => item.travelDetailId === travelDetailId,
    )

    // Update departureCityName value for record matched by travelDetailId
    if (currentIndex !== -1) {
      setDetailDataSource((prevState) => {
        const data = [...prevState]

        data[currentIndex] = {
          ...data[currentIndex],
          departureCityName: value,
        }
        return data
      })
    }
    onValidateArrivalMatchDepartureSameRecord()
  }

  const onBlurArrivalCityName = (value: string, travelDetailId: string) => {
    const currentIndex = detailDataSource.findIndex(
      (item) => item.travelDetailId === travelDetailId,
    )

    // Update arrivalCityName value for record matched by travelDetailId
    if (currentIndex !== -1) {
      setDetailDataSource((prevState) => {
        const data = [...prevState]

        data[currentIndex] = {
          ...data[currentIndex],
          arrivalCityName: value,
        }

        return data
      })
    }

    if (currentIndex !== detailDataSource.length - 1) {
      const currentData = detailDataSource[currentIndex]
      const nextData = detailDataSource[currentIndex + 1]
      const fieldName = `${setNameRowDetail(nextData.index)}.departureCityName`
      if (
        currentData.arrivalCityCode === nextData.departureCityCode &&
        currentData.arrivalCountryCode === nextData.departureCountryCode &&
        !form.getFieldValue(fieldName)
      ) {
        form.setFieldValue(fieldName, value)
      }
    }
    onValidateArrivalMatchDepartureSameRecord()
  }

  const getCities = async (
    departureCountryCode: string,
    arrivalCountryCode: string,
  ) => {
    const newPromise = new Promise<CitiesResType[]>((res) => res([]))

    // APIを呼び出し、都市一覧情報を取得する。
    const getDepartureCities: Promise<CitiesResType[]> = departureCountryCode
      ? countriesApi
          .getCitiesByCountry(departureCountryCode)
          .catch((error: AxiosErrorType) => {
            handleError(error)
          })
      : newPromise
    // APIを呼び出し、都市一覧情報を取得する。
    const getArrivalCities: Promise<CitiesResType[]> = arrivalCountryCode
      ? countriesApi
          .getCitiesByCountry(arrivalCountryCode)
          .catch((error: AxiosErrorType) => {
            handleError(error)
          })
      : newPromise

    const dataCities: CitiesResType[][] = await Promise.all([
      getDepartureCities,
      getArrivalCities,
    ])

    const departureCities = dataCities[0].map((item: CitiesResType) => ({
      text: item.cityDistrict,
      value: item.cityCode,
    }))

    const arrivalCities = dataCities[1].map((item: CitiesResType) => ({
      text: item.cityDistrict,
      value: item.cityCode,
    }))

    return {
      arrivalCities,
      departureCities,
    }
  }

  // SCR212_detail_set_row_data_table
  const handleSetDetailDataSource = async (
    data: HandleSetDetailDataSourceType,
  ) => {
    const {
      detailData,
      index,
      isClearDepartureFlight,
      isInitial,
      isSelectDepartureFlight,
    } = data

    const dataRemark = generalMastersRemark?.find(
      (item) => item.key1 === detailData.arrivalCountryCode,
    )
    const remarkNames = dataRemark ?? INITIAL_VALUES_REMARK_NAMES

    await setDetailFieldValue({
      detailData,
      form,
      index,
    })

    const { arrivalCities, departureCities } = await getCities(
      detailData.departureCountryCode,
      detailData.arrivalCountryCode,
    )

    const dataInsert = {
      ...detailData,
      arrivalCities: [...arrivalCities, OTHER_CITY_SELECT_ITEMS],
      departureCities: [...departureCities, OTHER_CITY_SELECT_ITEMS],
      index,
      key: detailData.travelDetailId,
      remarkNames,
    }

    if (isInitial) {
      setDetailDataSource((prevState) => [...prevState, dataInsert])

      setDetailIndexIdentity((prevState) => prevState + 1)
    } else {
      const _detailDataSource = [...detailDataSource]

      const dataSourceIndex = _detailDataSource.findIndex(
        (item) => item.travelDetailId === detailData.travelDetailId,
      )

      _detailDataSource.splice(dataSourceIndex, 1, dataInsert)

      setDetailDataSource(_detailDataSource)

      if (isSelectDepartureFlight || isClearDepartureFlight) {
        setTimeout(() => {
          form.setFields([
            {
              errors: [],
              name: `${setNameRowDetail(index)}.departureFlightNumber`,
            },
            {
              errors: [],
              name: `${setNameRowDetail(index)}.departureCityName`,
            },
            {
              errors: [],
              name: `${setNameRowDetail(index)}.arrivalCityName`,
            },
          ])
        }, 100)
      }
    }
  }

  const getItemTableRequiredField = () =>
    requiredField(isRequiredItemTableByPPTV)

  const checkRequiredLocationPhoneNumber1 = () =>
    requiredField(isRequiredLocationPhoneNumber1)

  const onChangeTransportation = (
    transportationValue: string,
    currentIndex: number,
  ) => {
    const _detailDataSource = [...detailDataSource]
    const currentItem = { ..._detailDataSource[currentIndex] }

    if (currentItem.transportation === TPTT001)
      form.setFields([
        {
          errors: [],
          name: `${setNameRowDetail(currentItem.index)}.departureFlightNumber`,
        },
      ])

    currentItem.transportation = transportationValue

    _detailDataSource.splice(currentIndex, 1, currentItem)
    setDetailDataSource(_detailDataSource)
  }

  // 「M.flightNumberList」に応じて「旅程情報」の初期表示処理を行う。
  const onSelectDepartureFlight = (
    value: string,
    travelDetailId: string,
    index?: number,
  ) => {
    const dataSelect = flightNumberListAll.find(
      (item) => item.departureFlightNumber === value,
    )

    if (dataSelect && typeof index === "number") {
      const itemRemark = `${setNameRowDetail(index)}.othersRemarks`
      handleSetDetailDataSource({
        detailData: {
          ...dataSelect,
          arrivalCities: [],
          departureCities: [],
          othersRemarks1: form.getFieldValue(`${itemRemark}1`),
          othersRemarks2: form.getFieldValue(`${itemRemark}2`),
          othersRemarks3: form.getFieldValue(`${itemRemark}3`),
          othersRemarks4: form.getFieldValue(`${itemRemark}4`),
          othersRemarks5: form.getFieldValue(`${itemRemark}5`),
          travelDetailId,
        },
        index,
        isSelectDepartureFlight: true,
      })
    }
  }

  const onClearDepartureFlight = (travelDetailId: string, index?: number) => {
    if (typeof index === "number") {
      const itemRemark = `${setNameRowDetail(index)}.othersRemarks`
      handleSetDetailDataSource({
        detailData: {
          ...ITINERARY_DATA_SOURCE_NEW,
          othersRemarks1: form.getFieldValue(`${itemRemark}1`),
          othersRemarks2: form.getFieldValue(`${itemRemark}2`),
          othersRemarks3: form.getFieldValue(`${itemRemark}3`),
          othersRemarks4: form.getFieldValue(`${itemRemark}4`),
          othersRemarks5: form.getFieldValue(`${itemRemark}5`),
          transportation: form.getFieldValue(
            `${setNameRowDetail(index)}.transportation`,
          ),
          travelDetailId,
        },
        index,
        isClearDepartureFlight: true,
      })
    }
  }

  const onChangePurposeTravel = async (value: string) => {
    if (PPTV_DOMESTIC_TRAVEL.includes(value)) {
      detailDataSource.forEach((item) => {
        form.setFieldsValue({
          [`${setNameRowDetail(item.index)}.departureCountryCode`]:
            workPlaceCountryCode,
          [`${setNameRowDetail(item.index)}.arrivalCountryCode`]:
            workPlaceCountryCode,
          [`${setNameRowDetail(item.index)}.departureCityCode`]: "",
          [`${setNameRowDetail(item.index)}.arrivalCityCode`]: "",
        })
      })

      const _detailDataSource = detailDataSource.map((item) => ({
        ...item,
        arrivalCities: defaultCountries,
        departureCities: defaultCountries,
      }))
      setDetailDataSource(_detailDataSource)
      setIsRequiredItemTableLodgings(false)
    } else {
      setIsRequiredItemTableLodgings(true)
    }
    if (listPPTVIsValue3Equal1.includes(value)) {
      if (!form.getFieldValue("bumonCd")) {
        form.setFieldValue("bumonCd", travelerBumonCd)
      }
      setIsActiveBumon(true)
    } else setIsActiveBumon(false)

    setIsRequiredItemTableByPPTV(!listPPTVIsValue4Equal2.includes(value))
    if (listPPTVIsValue5EqualTwoWay.includes(value)) {
      onOpenRoundTrip()
    } else {
      setIsTwoWay(false)
    }
    handleCheckHiredLocally(value)
  }

  const handleCheckTwoWay = () => {
    if (isCheckTwoWay) {
      return (
        detailDataSource.length === 1 &&
        listPPTVIsValue5EqualTwoWay.includes(
          form.getFieldValue("travelPurposeId"),
        )
      )
    } else {
      return false
    }
  }

  const onOkRoundTrip = () => {
    onCancelRoundTripModal()
    setIsCheckTwoWay(true)
  }

  const onCancelRoundTrip = () => {
    onCancelRoundTripModal()
    setIsCheckTwoWay(false)
    setIsTwoWay(false)
  }

  const onChangeDifferentInfo = (event: CheckboxChangeEvent) => {
    setIsDifferentInfoChecked(event.target.checked)
  }

  const onClickLodgingTab = (activeKey: string) => {
    setLodgingIndexTabActive(activeKey)
  }

  // SCR212_lodging_add
  const handleAddLodgingItem = (event?: MouseEvent<HTMLElement>) => {
    const travelLodgingId = `tempId${new Date().getTime().toString()}`

    setLodgingDataSource((prevState) => [
      ...prevState,
      {
        ...ACCOMMODATION_DATA_SOURCE_NEW,
        index: lodgingIndexIdentity,
        key: travelLodgingId,
        travelLodgingId,
      },
    ])

    setIsCheckAllLodging(false)
    setLodgingIndexIdentity(lodgingIndexIdentity + 1)
    setLodgingIndexTabActive((lodgingDataSource.length + 1).toString())
    const currentElement = setNameRowLodging(lodgingIndexIdentity)
    form.setFieldValue(`${currentElement}.travelLodgingId`, travelLodgingId)

    if (lodgingIndexIdentity && event) {
      setTimeout(() => {
        document.getElementById(`${currentElement}.lodgingCheckin`)?.focus()
      }, 100)
    }
  }

  // SCR212_lodging_delete
  const handleDeleteLodgingItem = (travelLodgingId?: string) => {
    if (travelLodgingId) {
      const _lodgingDataSource = lodgingDataSource.filter(
        (item) => item.travelLodgingId !== travelLodgingId,
      )

      setLodgingDataSource(_lodgingDataSource)

      setLodgingIndexTabActive("1")

      if (!_lodgingDataSource.length) handleAddLodgingItem()
    } else {
      const _lodgingDataSource = lodgingDataSource.filter(
        (item) =>
          item.travelLodgingId &&
          !lodgingSelectedRowKeys.includes(item.travelLodgingId),
      )

      setLodgingDataSource(_lodgingDataSource)

      setLodgingSelectedRowKeys([])

      if (!_lodgingDataSource.length) handleAddLodgingItem()
    }

    setTimeout(() => {
      const elmRows = document.querySelectorAll(
        "#table-schedules-add-lodging tbody > tr",
      )
      const emlInput = elmRows[elmRows.length - 1]?.querySelector(
        "td:nth-child(4) input",
      ) as HTMLInputElement
      emlInput?.focus()
    }, 100)
  }

  const onClickStayTab = (activeKey: string) => {
    setStayIndexTabActive(activeKey)
  }

  // SCR212_stay_add
  const handleAddStayItem = (event?: MouseEvent<HTMLElement>) => {
    const travelStayId = `tempId${new Date().getTime().toString()}`

    setStayDataSource((prevState) => [
      ...prevState,
      {
        ...PLACE_OF_STAY_CONTACT_DATA_SOURCE_NEW,
        index: stayIndexIdentity,
        key: travelStayId,
        travelStayId,
      },
    ])

    const emailAddress1FieldName = `${setNameRowStay(
      stayIndexIdentity,
    )}.emailAddress1`

    const personEmailAddress = form.getFieldValue("personEmailAddress")

    form.setFieldValue(emailAddress1FieldName, personEmailAddress)
    const currentElement = setNameRowStay(stayIndexIdentity)
    form.setFieldValue(`${currentElement}.travelStayId`, travelStayId)

    setIsCheckAllStay(false)
    setStayIndexIdentity(stayIndexIdentity + 1)
    setStayIndexTabActive((stayDataSource.length + 1).toString())

    if (stayIndexIdentity && event) {
      setTimeout(() => {
        document
          .getElementById(`${currentElement}.locationPhoneNumber1`)
          ?.focus()
      }, 100)
    }
  }

  // SCR212_stay_delete
  const handleDeleteStayItem = (travelStayId?: string) => {
    if (travelStayId) {
      const _stayDataSource = stayDataSource.filter(
        (item) => item.travelStayId !== travelStayId,
      )

      setStayDataSource(_stayDataSource)

      setStayIndexTabActive("1")

      if (!_stayDataSource.length) handleAddStayItem()
    } else {
      const _stayDataSource = stayDataSource.filter(
        (item) => !staySelectedRowKeys.includes(item.travelStayId),
      )

      setStayDataSource(_stayDataSource)

      setStaySelectedRowKeys([])

      if (!_stayDataSource.length) handleAddStayItem()
    }

    setTimeout(() => {
      const elmRows = document.querySelectorAll(
        "#table-schedules-add-stay tbody > tr",
      )
      const emlInput = elmRows[elmRows.length - 1]?.querySelector(
        "td:nth-child(4) input",
      ) as HTMLInputElement
      emlInput?.focus()
    }, 100)
  }

  const onValuesChange = (values?: AnyValue) => {
    setIsSubmitValidate(false)
    const dataFields = [
      ...SCHEDULES_ADD_REQUIRED_FIELDS,
      ...detailRequiredFields,
      ...stayRequiredFields,
    ]

    if (values) {
      const shouldClearDetailFields = Object.keys(values).some((key) =>
        REGEX_ARRIVAL_DEPARTURE_VALIDATION_TRIGGER_FIELD.test(key),
      )

      if (shouldClearDetailFields) {
        detailDataSource.forEach(({ index }) => {
          form.setFields([
            {
              errors: [],
              name: [`${setNameRowDetail(index)}.departureCountryCode`],
            },
          ])
        })
      }
    }

    if (isRequiredLabelLodgings) {
      dataFields.push(...lodgingRequiredFields)
    } else {
      const fields = lodgingRequiredFields.map((item) => ({
        errors: [],
        name: item,
      }))

      form.setFields(fields)
    }

    if (!isRequiredLocationPhoneNumber1) {
      const fields = stayRequiredFields.map((item) => ({
        errors: [],
        name: item,
      }))

      form.setFields(fields)
    }

    if (isActiveBumon) dataFields.push("bumonCd")
    if (isHiredLocally)
      dataFields.push(...["dispatchStartDate", "dispatchEndDate"])
    else {
      dataFields.filter(
        (item) => item !== "dispatchStartDate" && item !== "dispatchEndDate",
      )
    }

    const valueDifferentInfoChecked = form.getFieldValue("differentInforCheck")
    if (valueDifferentInfoChecked) dataFields.push("insuranceCompanyName")
    else
      form.setFields([
        {
          errors: [],
          name: "insuranceCompanyName",
        },
      ])

    const _isInsuranceRequired = !form
      .getFieldValue("insuranceCompanyName")
      ?.includes(TEXT_T100)

    setIsInsuranceRequired(_isInsuranceRequired)

    if (valueDifferentInfoChecked && _isInsuranceRequired)
      dataFields.push(...INSURANCE_REQUIRED_FIELDS)
    else
      form.setFields([
        {
          errors: [],
          name: INSURANCE_REQUIRED_FIELDS[0],
        },
        {
          errors: [],
          name: INSURANCE_REQUIRED_FIELDS[1],
        },
        {
          errors: [],
          name: INSURANCE_REQUIRED_FIELDS[2],
        },
      ])

    const isArrivalMatchDepartureSameRecord =
      !isHiredLocally && onValidateArrivalMatchDepartureSameRecord()

    const formValues = form.getFieldsValue(dataFields)
    const tableDetailsValue = form.getFieldsValue(detailRequiredFields)

    setIsRequiredItemTableDetails(
      Object.values(tableDetailsValue).some((item) => !item),
    )
    if (
      !formValues.codeConductConfirmation ||
      isArrivalMatchDepartureSameRecord
    )
      setIsDisabledSubmit(true)
    else setIsDisabledSubmit(Object.values(formValues).some((item) => !item))
  }

  const onValidateChangeDate = () => {
    const data: string[] = []
    if (detailDataSource.length) {
      detailDataSource.forEach((item) => {
        const arrivalDate = form.getFieldValue(
          `${setNameRowDetail(item.index)}.arrivalDate`,
        )
        const departureDate = form.getFieldValue(
          `${setNameRowDetail(item.index)}.departureDate`,
        )
        data.push(getDateRange(arrivalDate, true))
        data.push(getDateRange(departureDate, true))
      })
      const isAllEqual = data.every((item) => item === data[0] && item !== "")
      setIsRequiredItemTableByDate(!isAllEqual)
    } else {
      setIsRequiredItemTableByDate(true)
    }
  }

  const onChangeDate = (name: string) => {
    form.setFields([
      {
        errors: [],
        name,
      },
    ])
  }

  const { onBlur, onKeyDown } = useDatePicker({
    form,
    isRequired: isHiredLocally,
    onValuesChange,
  })

  const { onBlur: onLodgingsBlur, onKeyDown: onLodgingsKeyDown } =
    useDatePicker({
      form,
      isRequired: isRequiredLabelLodgings,
      onValuesChange,
    })

  const { detailTabsItems, lodgingTabsItems, stayTabsItems } =
    useSchedulesAddTabConfig({
      allCountries,
      checkRequiredLocationPhoneNumber1,
      detailDataSource,
      flightNumberList,
      getFieldValue: form.getFieldValue,
      getItemTableRequiredField,
      handleAddDetailItem,
      handleAddLodgingItem,
      handleAddStayItem,
      handleDeleteDetailItem,
      handleDeleteLodgingItem,
      handleDeleteStayItem,
      isRequiredItemTableByPPTV,
      isRequiredLocationPhoneNumber1,
      isSubmitValidate,
      isVisibleBtn,
      lodgingDataSource,
      onBlur,
      onChangeCity,
      onChangeCountry,
      onChangeDate,
      onChangeTransportation,
      onClearDepartureFlight,
      onKeyDown,
      onSelectDepartureFlight,
      stayDataSource,
      transportationList,
    })

  const { columns: detailColumnsFirst } = useTableDetailsConfig({
    allCountries,
    flightNumberList,
    getFieldValue: form.getFieldValue,
    onBlur,
    onBlurArrivalCityName,
    onBlurDepartureCityName,
    onChangeCity,
    onChangeCountry,
    onChangeDate,
    onChangeTransportation,
    onClearDepartureFlight,
    onKeyDown,
    onSelectDepartureFlight,
    onValidateChangeDate,
    transportationList,
  })

  const { columns: detailColumnsSecond } = useTableRemarksConfig()

  const { columns: lodgingColumns } = useTableLodgingsConfig({
    isRequiredLabel: isRequiredLabelLodgings,
    isSubmitValidate,
    onBlur: onLodgingsBlur,
    onChangeDate,
    onKeyDown: onLodgingsKeyDown,
  })

  const { columns: stayColumns } = useTableStaysConfig({
    checkRequiredLocationPhoneNumber1,
    isRequiredLocationPhoneNumber1,
  })

  const handleErrorValidate = (message: string, entityName?: string) => {
    const messages = [E0017, E0105, E0107]
    if (messages.includes(message)) {
      if (entityName === "lodging") {
        setLodgingValidMsg(translateMessage(`MESSAGE.${message}`))
        setDefaultActiveKey((prevState) => [...prevState, "6"])
        scrollToCollapseItem(5)
      } else {
        setDetailValidMsg(translateMessage(`MESSAGE.${message}`))
        setDefaultActiveKey((prevState) => [...prevState, "5"])
        scrollToCollapseItem(4)
      }
    } else {
      setAssignmentValidMsg(translateMessage(`MESSAGE.${message}`))
      setDefaultActiveKey((prevState) => [...prevState, "3"])
      scrollToCollapseItem(2)
    }
  }

  const onChangeCollapse = (key: string[]) => {
    setDefaultActiveKey(key)
  }

  // 「SCR960_渡航予定情報の複製画面」に遷移する 。
  const goToSchedulesClone = () => {
    if (pathname === replaceString(SCR212, id))
      push({
        pathname: SCR960,
        state: {
          ...state,
          isFromSCR212: true,
          sourceURL: pathname,
          travelerId,
        },
      })

    if (pathname === replaceString(SCR212_USER, id))
      push({
        pathname: SCR960,
        state: {
          ...state,
          isFromSCR212User: true,
          sourceURL: pathname,
          travelerId,
        },
      })
  }

  const getInitialValues = (
    _schedulesInfo: ScheduleInfoType,
    _purposeTravelList: OptionItemType[],
    _departments: OptionItemType[],
  ): InitialValuesType => ({
    ..._schedulesInfo,
    bumonCd: _departments.some((item) => item.value === _schedulesInfo.bumonCd)
      ? _schedulesInfo.bumonCd
      : "",
    dispatchEndDate: getDateUtc(_schedulesInfo.dispatchEndDate),
    dispatchStartDate: getDateUtc(_schedulesInfo.dispatchStartDate),
    travelPurposeId: _purposeTravelList.some(
      (item) => item.value === _schedulesInfo.travelPurposeId,
    )
      ? _schedulesInfo.travelPurposeId
      : "",
  })

  const onFinish = () => {
    // 確認ダイアログボックスを作成する。
    setIsSubmitValidate(true)
  }

  const handleCheckSubmitValidate = () => {
    if (isSubmitValidate) {
      form
        .validateFields()
        .then(() => {
          onOpen()
          setDataSubmit(form.getFieldsValue())
        })
        .catch((error: FormErrorType) => {
          form.scrollToField(error.errorFields[0].name.toString())
          const elmError = document.getElementById(
            error.errorFields[0].name.toString(),
          ) as HTMLInputElement
          if (elmError) elmError.focus()
        })
    }
  }

  const getFlightInfo = async (_travelerId: string) => {
    // APIを呼び出し、渡航者の出発便名情報を取得し
    await scheduleApi
      .getFlightInfo(_travelerId)
      .then((res: ScheduleDetailsType[]) => {
        const _flightNumberListAll = res.map((item) => ({
          ...item,
          arrivalCityNameOther:
            item.arrivalCityCode === OTHER ? item.arrivalCityName : "",
          departureCityNameOther:
            item.departureCityCode === OTHER ? item.departureCityName : "",
        }))

        setFlightNumberListAll(_flightNumberListAll)

        setFlightNumberList(
          res.map((item) => ({
            label: item.departureFlightNumber,
          })),
        )
      })
      .catch((error: AxiosErrorType) => {
        handleError(error)
      })
  }

  const setDataScheduleLodgings = () => {
    scheduleLodgings.forEach((item, index) => {
      const baseFieldName = `schedulesAddLodging.${index}`

      form?.setFieldsValue({
        [`${baseFieldName}.lodgingAddress`]: item.lodgingAddress,
        [`${baseFieldName}.lodgingCheckin`]: getDateUtc(item.lodgingCheckin),
        [`${baseFieldName}.lodgingCheckout`]: getDateUtc(item.lodgingCheckout),
        [`${baseFieldName}.lodgingName`]: item.lodgingName,
        [`${baseFieldName}.lodgingPhoneNumber`]: item.lodgingPhoneNumber,
        [`${baseFieldName}.travelLodgingId`]: item.travelLodgingId,
      })
    })

    setLodgingDataSource(
      [...scheduleLodgings].map((item, index) => {
        item.index = index
        item.key = item.travelLodgingId

        setLodgingIndexIdentity((prevState) => prevState + 1)

        return item
      }),
    )
  }

  const setDataScheduleDetails = () => {
    scheduleDetails.reduce(async (prevItem, currentItem, currentIndex) => {
      await prevItem

      return await handleSetDetailDataSource({
        detailData: currentItem,
        index: currentIndex,
        isInitial: true,
      })
    }, Promise.resolve())
  }

  const setDataScheduleStays = () => {
    scheduleStays.forEach((item, index) => {
      const baseFieldName = `schedulesAddStay.${index}`

      form?.setFieldsValue({
        [`${baseFieldName}.emailAddress1`]: item.emailAddress1,
        [`${baseFieldName}.emailAddress2`]: item.emailAddress2,
        [`${baseFieldName}.locationPhoneNumber1`]: item.locationPhoneNumber1,
        [`${baseFieldName}.locationPhoneNumber2`]: item.locationPhoneNumber2,
        [`${baseFieldName}.satellitePhoneNumber`]: item.satellitePhoneNumber,
        [`${baseFieldName}.travelStayId`]: item.travelStayId,
      })
    })

    setStayDataSource(
      [...scheduleStays].map((item, index) => {
        item.index = index
        item.key = item.travelStayId

        setStayIndexIdentity((prevState) => prevState + 1)

        return item
      }),
    )
  }

  const handleCheckInsuranceAndUrgent = (data: TravelersDetailResType) => {
    const { base, detail } = data
    const { dispatchTypeDetailId } = base
    const {
      insuranceCompanyName,
      insuranceCompanyPhoneNumber,
      insuranceSonsignor,
      insuranceTicketNumber,
      urgentAffiliationContact,
      urgentAffiliationContactName,
      urgentContactHome,
      urgentContactName,
    } = detail
    const checkData = (length: number, ...res: string[]) =>
      res.filter(Boolean).length < length

    const isRequiredDefault = checkData(
      3,
      urgentContactHome,
      urgentContactName,
      insuranceCompanyName,
    )

    const isRequiredUrgent = checkData(
      2,
      urgentAffiliationContact,
      urgentAffiliationContactName,
    )

    const isRequiredInsurance = checkData(
      3,
      insuranceCompanyPhoneNumber,
      insuranceSonsignor,
      insuranceTicketNumber,
    )

    if (
      isRequiredDefault ||
      (DPTD_REQUIRED_URGENT_CONTACT.includes(dispatchTypeDetailId) &&
        isRequiredUrgent) ||
      (insuranceCompanyName !== TEXT_T100 && isRequiredInsurance)
    ) {
      setIsInsuranceAndUrgent(true)
    }
  }

  const getPurposeTravelList = (props: GetPurposeTravelListProps) => {
    const {
      dispatchTypeDetailId,
      dispatchTypeDetailRes,
      purposeTravelRes,
      workPlaceLocation,
    } = props
    if (dispatchTypeDetailId) {
      const dispatchTypeDetailInfo = dispatchTypeDetailRes?.find(
        (item) => item.key1 === dispatchTypeDetailId,
      )

      if (dispatchTypeDetailInfo) {
        const _purposeTravelRes = purposeTravelRes || []
        const businessTravelIndex = _purposeTravelRes.findIndex(
          (item) => item.key1 === PPTV_BUSINESS_TRAVEL,
        )

        if (businessTravelIndex && businessTravelIndex !== -1) {
          const item = _purposeTravelRes.splice(businessTravelIndex, 1)[0]
          _purposeTravelRes.unshift(item)
        }

        const _purposeTravelList =
          _purposeTravelRes
            .filter((item) => item.key2 === dispatchTypeDetailInfo.key3)
            .map((item) => {
              if (item.value3 === "1")
                setListPPTVIsValue3Equal1((prev) => [...prev, item.key1])

              if (item.value4 === "2")
                setListPPTVIsValue4Equal2((prev) => [...prev, item.key1])
              if (item.value5 === "往復")
                setListPPTVIsValue5EqualTwoWay((prev) => [...prev, item.key1])
              return {
                text: String(getValueByLanguage(item.value1, item.value2)),
                value: item.key1,
              }
            }) || []
        if (_purposeTravelList.length) {
          const { key1, key3 } = dispatchTypeDetailInfo

          if (
            (key3 === DPTD_KEY3_2 && !DPTD_HIRED_LOCALLY.has(key1)) ||
            (key3 === DPTD_KEY3_7 && DPTD_TRAINEE.has(key1)) ||
            workPlaceLocation !== 1
          ) {
            const tempPurposeTravelList = _purposeTravelList.filter(
              (item) => !PPTV_HIRED_LOCALLY.has(item.value),
            )
            setPurposeTravelList(tempPurposeTravelList)
            return tempPurposeTravelList
          }
          setPurposeTravelList(_purposeTravelList)
          return _purposeTravelList
        }
        return _purposeTravelList
      }
      return []
    }
    return []
  }

  const onDispatchTypeDetailChange = (value: string) => {
    form.setFieldValue("travelPurposeId", "")
    getPurposeTravelList({
      dispatchTypeDetailId: value,
      dispatchTypeDetailRes,
      purposeTravelRes,
      workPlaceLocation,
    })
    handleCheckHiredLocally("")
  }

  const handleCheckHiredLocally = (purposeTravel: string) => {
    const _purposeTravel = PPTV_HIRED_LOCALLY.has(purposeTravel)

    setIsHiredLocally(_purposeTravel)
    if (!_purposeTravel) {
      form.setFields([
        { errors: [], name: "dispatchStartDate" },
        { errors: [], name: "dispatchEndDate" },
      ])
    }
  }

  return {
    assignmentValidMsg,
    dataSubmit,
    defaultActiveKey,
    departments,
    detailColumnsFirst,
    detailColumnsSecond,
    detailDataSource,
    detailIndexIdentity,
    detailIndexTabActive,
    detailRowSelection,
    detailSelectedRowKeys,
    detailTabsItems,
    detailValidMsg,
    dispatchType,
    dispatchTypeDetailRes,
    form,
    getFlightInfo,
    getInitialValues,
    getPurposeTravelList,
    goToSchedulesClone,
    handleAddDetailItem,
    handleAddLodgingItem,
    handleAddStayItem,
    handleCheckHiredLocally,
    handleCheckInsuranceAndUrgent,
    handleCheckSubmitValidate,
    handleCheckTwoWay,
    handleDeleteDetailItem,
    handleDeleteLodgingItem,
    handleDeleteStayItem,
    handleError,
    handleErrorValidate,
    handleSetDetailRequiredFields,
    handleSetLodgingRequiredFields,
    handleSetStayRequiredFields,
    isAccompanyingFamily,
    isActiveBumon,
    isDifferentInfoChecked,
    isDisabledSubmit,
    isHiredLocally,
    isInsuranceAndUrgent,
    isInsuranceRequired,
    isOpen,
    isOpenRoundTrip,
    isOtherStaffNumber,
    isRequiredItemTableByDate,
    isRequiredItemTableByPPTV,
    isRequiredItemTableDetails,
    isRequiredItemTableLodgings,
    isSubmitValidate,
    isTwoWay,
    listPPTVIsValue3Equal1,
    listPPTVIsValue4Equal2,
    lodgingColumns,
    lodgingDataSource,
    lodgingIndexIdentity,
    lodgingIndexTabActive,
    lodgingRowSelection,
    lodgingSelectedRowKeys,
    lodgingTabsItems,
    lodgingValidMsg,
    onBlur,
    onCancel,
    onCancelRoundTrip,
    onChangeCollapse,
    onChangeDate,
    onChangeDifferentInfo,
    onChangePurposeTravel,
    onClickDetailTab,
    onClickLodgingTab,
    onClickStayTab,
    onDispatchTypeDetailChange,
    onFinish,
    onKeyDown,
    onOkRoundTrip,
    onValidateChangeDate,
    onValuesChange,
    purposeTravelList,
    scheduleDetails,
    scheduleLodgings,
    scheduleStays,
    schedulesData,
    setAssignmentValidMsg,
    setDataScheduleDetails,
    setDataScheduleLodgings,
    setDataScheduleStays,
    setDefaultCountries,
    setDepartments,
    setDetailDataSource,
    setDetailValidMsg,
    setDispatchType,
    setDispatchTypeDetailRes,
    setIsAccompanyingFamily,
    setIsActiveBumon,
    setIsDifferentInfoChecked,
    setIsHiredLocally,
    setIsOtherStaffNumber,
    setIsRequiredItemTableByPPTV,
    setIsRequiredItemTableLodgings,
    setIsTwoWay,
    setListPPTVIsValue3Equal1,
    setListPPTVIsValue5EqualTwoWay,
    setLodgingDataSource,
    setLodgingValidMsg,
    setPurposeTravelRes,
    setSchedulesData,
    setStayDataSource,
    setTravelerBumonCd,
    setTravelerId,
    setWorkPlaceCountryCode,
    setWorkPlaceLocation,
    stayColumns,
    stayDataSource,
    stayIndexIdentity,
    stayIndexTabActive,
    stayRowSelection,
    staySelectedRowKeys,
    stayTabsItems,
    travelerBumonCd,
    travelerId,
  }
}
